'use client';

import React from 'react';

import { Button } from '@depop/web-ui-kit/Button';
import { useParams } from 'next/navigation';

import styles from './styles.module.css';

import { ExtendedLink } from '@/components/ExtendedLink';
import { ActivityTrackerEventType } from '@/modules/activityTracker/constants';
import { useActivityTracker } from '@/modules/activityTracker/useActivityTracker';
import { getPartnerActivityTrackingPageName } from '@/modules/partners/getPartnerActivityTrackingPageName';
import { useCurrentUser } from '@/modules/user/useCurrentUser';

type Props = {
  ctaText: string;
  redemptionLink: string;
};

export function RedemptionButton({ ctaText, redemptionLink }: Props) {
  const [_, currentUser] = useCurrentUser();
  const { sendActivityTrackerEvent: sendATEvent } = useActivityTracker({
    userId: currentUser?.id,
  });
  const { partner } = useParams<{ partner: string }>();

  function handleClick() {
    sendATEvent(ActivityTrackerEventType.CTA_ACTION, {
      type: getPartnerActivityTrackingPageName(partner),
    });
  }

  return (
    <ExtendedLink href={redemptionLink}>
      <Button size="lg" onClick={handleClick} className={styles.heroButton}>
        {ctaText}
      </Button>
    </ExtendedLink>
  );
}
